import React from "react";

const IconFrFlag = () => {
  return (
    <svg
      width="21"
      height="14"
      viewBox="0 0 21 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect
        x="0.363281"
        width="19.7919"
        height="14"
        fill="url(#pattern0_4150_6829)"
      />
      <defs>
        <pattern
          id="pattern0_4150_6829"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_4150_6829"
            transform="matrix(0.00386535 0 0 0.00546448 -0.0314857 0)"
          />
        </pattern>
        <image
          id="image0_4150_6829"
          width="275"
          height="183"
          preserveAspectRatio="none"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARMAAAC3CAMAAAAGjUrGAAAAOVBMVEUBJn//GSb////9GSb+Gif/EyP6CRr9dYP///D/+v/z//3/+fn7//38//r//f9reqUAHH0CJI8AJ3Ja8KYQAAABEElEQVR4nO3QRwGAMBAAsNIeo2zwLxYT3C+RkFKSvM991X4e9W/7tta+zNMY0VoMCbJKnDhx4sSJEydOnDhx4sSJEydOnDhx4sSJEydOnDhx4sSJEydOnDhx4sSJEydOnDhx4sSJEydOnDhx4sSJEydOnDhx4sSJEydOnDhx4sSJEydOnDhx4sSJEydOnDhx4sSJEydOnDhx4sSJEydOnDhx4sSJEydOnDhx4sSJEydOnDhx4sSJEydOnDhx4sSJEydOnDhx4sSJEydOnDhx4sSJEydOnDhx4sSJEydOnDhx4sSJEydOnDhx4sSJEydOnDhx4sSJEydOnDhx4sSJEydOnDhx4sSJEydOnDjJPPkAKL05KmTHLZsAAAAASUVORK5CYII="
        />
      </defs>
    </svg>
  );
};

export default IconFrFlag;
